import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import { CASHIER_VISUAL } from "./CashierConfig";
import { CashierPreviewImage } from "./CashierPreviewImage";

export interface CashierQrSlotProps {
  codeUrl?: string;
  paying?: boolean;
}

export const CashierQrSlot: React.FC<CashierQrSlotProps> = ({ codeUrl, paying }) => {
  const [dataUrl, setDataUrl] = useState("");
  const trimmedCode = codeUrl?.trim() ?? "";

  useEffect(() => {
    if (!trimmedCode) {
      setDataUrl("");
      return undefined;
    }
    let cancelled = false;
    void (async () => {
      try {
        const url = await QRCode.toDataURL(trimmedCode, {
          width: CASHIER_VISUAL.webQrCodeSizePx,
          margin: CASHIER_VISUAL.webQrCodeMarginPx,
          errorCorrectionLevel: "M",
        });
        if (!cancelled) {
          setDataUrl(url);
        }
      } catch {
        if (!cancelled) {
          setDataUrl("");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [trimmedCode]);

  const hint = dataUrl
    ? "请打开微信扫一扫完成支付"
    : paying
      ? "正在生成微信支付二维码…"
      : "选择支付方式获取支付二维码";

  return (
    <div className="cashier-qr-placeholder">
      <div
        className={
          dataUrl
            ? "cashier-qr-placeholder-box cashier-qr-placeholder-box--filled"
            : "cashier-qr-placeholder-box"
        }
      >
        {paying && !dataUrl ? (
          <span className="cashier-qr-placeholder-loading">生成中…</span>
        ) : null}
        {dataUrl ? (
          <CashierPreviewImage
            src={dataUrl}
            alt="微信支付二维码"
            className="cashier-qr-placeholder-img"
            previewAriaLabel="查看支付二维码大图"
          />
        ) : null}
      </div>
      <p className="cashier-qr-placeholder-hint">{hint}</p>
    </div>
  );
};
